import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { getAccountCodeData, getServDashScreenByCode, getServiceDashboardData } from '../../../../Core/Service/ManageAccount/servDash-service';
import { AppStorage } from '../../../../Core/Service/storage-service';
import { getManageAccountDropdown } from '../../../../Core/Service/period-service';
import AppContext from '../../../../App/AppContext';
export const BranchFranchiseCompareContext = createContext();

const calculateKIP = (total, value) => {
    if (total) {
        return (value / total) * 100;
    } else {
        return 0;
    }
};

const periodList = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' },
    { id: 13, name: 'Q1' },
    { id: 14, name: 'Q2' },
    { id: 15, name: 'Q3' },
    { id: 16, name: 'Q4' },
    { id: 17, name: 'H1' },
    { id: 18, name: 'H2' }
];
export const BranchFranchiseServiceProvider = (props) => {
    const tableRef = useRef();

    let local_Storage_ID = localStorage._managementAccountDefaultDashboardID_;

    const portalSettings = AppStorage.getPortalSetting();

    const { showToast } = useContext(AppContext);

    function ThousandSeparatorWithoutZero(value, decimals = 0) {
        const num = Number(value);
        if (isNaN(num)) return '0';

        return num.toLocaleString(undefined, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    }

    let portalSettingMADashboardActualAlign = portalSettings.portalSettingMADashboardActualAlign;
    let portalSettingMADashboardActualName = portalSettings.portalSettingMADashboardActualName;
    let portalSettingMADashboardActualPYAlign = portalSettings.portalSettingMADashboardActualPYAlign;
    let portalSettingMADashboardActualPYName = portalSettings.portalSettingMADashboardActualPYName;
    let portalSettingMADashboardBudgetAlign = portalSettings.portalSettingMADashboardBudgetAlign;
    let portalSettingMADashboardBudgetName = portalSettings.portalSettingMADashboardBudgetName;
    let portalSettingMADashboardKPIsAlign = portalSettings.portalSettingMADashboardKPIsAlign;
    let portalSettingMADashboardKPIsName = portalSettings.portalSettingMADashboardKPIsName;
    let portalSettingMADashboardVarLYName = portalSettings.portalSettingMADashboardVarLYName;
    let portalSettingMADashboardVarPYAlign = portalSettings.portalSettingMADashboardVarPYAlign;
    let portalSettingMADashboardVarianceAlign = portalSettings.portalSettingMADashboardVarianceAlign;
    let portalSettingMADashboardVarianceName = portalSettings.portalSettingMADashboardVarianceName;

    const [screenDetails, setScreenDetails] = useState({
        bgColor: '',
        hasBranch: false,
        hasFranchise: false,
        hasPeriod: false,
        hasYear: false,
        maDashboardID: 1,
        name: '',
        txtColor: '',
        defaultBranches: [],
        defaultFranchises: []
    });
    const [dropDown, setDropDown] = useState({
        branch: [],
        franchise: []
    });

    const [loader, setLoader] = useState(true);
    const [screenDashboardID, setScreenDashboardID] = useState(+local_Storage_ID);
    const [screenLoader, setScreenLoader] = useState(true);

    const [categoryList, setCategoryList] = useState([]);
    const [catName, setCatNames] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [state, setState] = useState({
        branch: [],
        branchNewList: [],
        yearID: null,
        filterdData: [],
        franchise: [],
        filterStateArray: [],
        period: null,
        isLoader: true,
        openAccountCodes: false,
        showYTD: true
    });

    const [accountData, setAccountData] = useState({
        branch: '',
        franchise: '',
        period: '',
        catName: '',
        mainCat: ''
    });

    const [accountCodes, setAccountCodes] = useState([]);

    const [Collapse, setCollapse] = useState({});

    // const [headerArray, setHeaderArray] = useState([]);

    const handleCollaps = (id) => {
        setCollapse((st) => ({
            ...st,
            [id]: !st[id]
        }));
    };

    useEffect(() => {
        if (categoryList.length > 0) {
            let filterRow = [...categoryList];
            setCollapse((st) => {
                let newSt = { ...st };
                filterRow.forEach((k) => {
                    newSt[k.categoryId] = k.isExpanded ? false : true;
                });
                return newSt;
            });
        }
    }, [categoryList]);

    const handleShowYTD = (e) => {
        setState({ ...state, showYTD: e.target.checked });

        // setState((st) => ({ ...st, showYTD: !st.showYTD }));
    };

    const getNumericKeys = (obj) => Object.keys(obj).filter((key) => key !== 'maDashboardCategoryId' && typeof obj[key] === 'number');

    const groupBy = (arr, key) =>
        arr.reduce((acc, item) => {
            const val = item[key];
            if (!acc[val]) acc[val] = [];
            acc[val].push(item);
            return acc;
        }, {});

    const extractUsedCategoryIds = (calculation) => {
        try {
            if (typeof calculation !== 'string') return [];

            const matches = [...calculation.matchAll(/#(\d+)#/g)];
            return matches.map((m) => Number(m[1])).filter((n) => !isNaN(n));
        } catch (error) {
            console.error('Error extracting category IDs:', error);
            return [];
        }
    };

    const getCalculatedData = (groupedData, calculation, categoryId) => {
        const usedCategoryIds = extractUsedCategoryIds(calculation);
        const filteredData = groupedData.filter((item) => usedCategoryIds.includes(item.maDashboardCategoryId));

        if (filteredData.length === 0) return [];

        const allowedKeys = ['actual', 'actualLY', 'budget', 'varLY', 'variance', 'ytdActual', 'ytdActualLY', 'ytdBudget', 'ytdVarLY', 'ytdVariance'];

        const allNumericKeys = getNumericKeys(filteredData[0]);
        const numericKeys = allNumericKeys.filter((key) => allowedKeys.includes(key));

        const groupedByCategoryName = groupBy(filteredData, 'maMappingCategoryName');

        return Object.entries(groupedByCategoryName).map(([categoryName, group]) => {
            const firstItem = group[0];
            const output = {
                maMappingCategoryName: categoryName,
                mappingCategoryID: categoryId,
                catID: categoryId
            };

            // Copy non-numeric, non-category-specific fields
            Object.keys(firstItem).forEach((key) => {
                if (!numericKeys.includes(key) && key !== 'maDashboardCategoryId' && key !== 'maMappingCategoryName') {
                    output[key] = firstItem[key];
                }
            });

            // Compute values for numeric keys
            for (const key of numericKeys) {
                try {
                    const valueMap = Object.fromEntries(group.map((item) => [item.maDashboardCategoryId, item[key] ?? 0]));

                    // Replace #id# with actual numbers (or 0 if not found)
                    const expr = calculation.replace(/#(\d+)#/g, (_, id) => {
                        const val = valueMap[id];
                        return typeof val === 'number' ? val : 0;
                    });

                    // Safely evaluate the expression
                    let calcValue = 0;
                    try {
                        calcValue = Function(`"use strict"; return (${expr})`)();
                        if (!isFinite(calcValue) || isNaN(calcValue)) {
                            calcValue = 0;
                        }
                    } catch (evalError) {
                        console.error(`Error evaluating expression "${expr}" for key "${key}":`, evalError);
                        calcValue = 0;
                    }

                    output[key] = calcValue;
                } catch (error) {
                    console.error(`Error processing key "${key}" for category "${categoryName}":`, error);
                    output[key] = 0;
                }
            }

            return output;
        });
    };

    const getCalculatedBranchData = (branch, isCalculation, calculation, categoryId) => {
        const groupedData = getBranchData(branch);
        if (isCalculation) {
            return getCalculatedData(groupedData, calculation, categoryId).sort((a, b) => a.sequence - b.sequence);
        }
        return [];
    };

    const getCalculatedFranchiseData = (branch, franchise, isCalculation, calculation, categoryId) => {
        let groupedData = dataList
            .filter((item) => (branch == '-99' ? item.franchise === franchise : item.branch === branch && item.franchise === franchise))
            .reduce((acc, obj) => {
                var index = acc.find(
                    (item) => item.maDashboardCategoryId === obj.maDashboardCategoryId && item.maMappingCategoryName === obj.maMappingCategoryName
                );

                if (index) {
                    index.actual += obj.actual;
                    index.budget += obj.budget;
                    index.actualLY += obj.actualLY;
                    index.varLY += obj.varLY;
                    index.ytdActual += obj.ytdActual;
                    index.ytdActualLY += obj.ytdActualLY;
                    index.ytdBudget += obj.ytdBudget;
                    index.ytdVarLY += obj.ytdVarLY;
                    index.ytdVariance += obj.ytdVariance;
                    index.variance += obj.variance;
                } else {
                    acc.push({ ...obj });
                }

                return acc;
            }, []);

        if (isCalculation && groupedData.length > 0) {
            return getCalculatedData(groupedData, calculation, categoryId).sort((a, b) => a.sequence - b.sequence);
        }

        return [];
    };

    const getBranchData = (branch) => {
        let total = 0;
        let groupedData = [];
        if (branch == '-99') {
            groupedData = dataList.reduce((acc, obj) => {
                var index = acc.find(
                    (item) => item.maDashboardCategoryId === obj.maDashboardCategoryId && item.maMappingCategoryName === obj.maMappingCategoryName
                );

                if (index) {
                    index.actual += obj.actual;
                    index.budget += obj.budget;
                    index.actualLY += obj.actualLY;
                    index.varLY += obj.varLY;
                    index.ytdActual += obj.ytdActual;
                    index.ytdActualLY += obj.ytdActualLY;
                    index.ytdBudget += obj.ytdBudget;
                    index.ytdVarLY += obj.ytdVarLY;
                    index.ytdVariance += obj.ytdVariance;
                    index.variance += obj.variance;
                } else {
                    acc.push({ ...obj });
                }

                return acc;
            }, []);
        } else {
            groupedData = dataList
                .filter((fil) => fil.branch == branch)
                .reduce((acc, obj) => {
                    var index = acc.find(
                        (item) => item.maDashboardCategoryId === obj.maDashboardCategoryId && item.maMappingCategoryName === obj.maMappingCategoryName
                    );

                    if (index) {
                        index.actual += obj.actual;
                        index.budget += obj.budget;
                        index.actualLY += obj.actualLY;
                        index.varLY += obj.varLY;
                        index.ytdActual += obj.ytdActual;
                        index.ytdActualLY += obj.ytdActualLY;
                        index.ytdBudget += obj.ytdBudget;
                        index.ytdVarLY += obj.ytdVarLY;
                        index.ytdVariance += obj.ytdVariance;
                        index.variance += obj.variance;
                    } else {
                        acc.push({ ...obj });
                    }

                    return acc;
                }, []);
        }

        return groupedData || [];
    };
    const getFrenChiseData = (branch, catID, franchise) => {
        let groupedData = [];
        if (branch == '-99') {
            groupedData = dataList
                .filter((fil) => fil.maDashboardCategoryId === catID && fil.franchise === franchise)
                .reduce((acc, obj) => {
                    var index = acc.find(
                        (item) => item.maMappingCategoryName === obj.maMappingCategoryName && item.maDashboardCategoryId === obj.maDashboardCategoryId
                    );

                    if (index) {
                        index.actual += obj.actual;
                        index.budget += obj.budget;
                        index.actualLY += obj.actualLY;
                        index.varLY += obj.varLY;
                        index.ytdActual += obj.ytdActual;
                        index.ytdActualLY += obj.ytdActualLY;
                        index.ytdBudget += obj.ytdBudget;
                        index.ytdVarLY += obj.ytdVarLY;
                        index.ytdVariance += obj.ytdVariance;
                        index.variance += obj.variance;
                    } else {
                        acc.push({ ...obj });
                    }

                    return acc;
                }, [])
                .sort((a, b) => a.sequence - b.sequence);
        } else {
            groupedData = dataList
                .sort((a, b) => a.sequence - b.sequence)
                .filter((fil) => fil.maDashboardCategoryId == catID && fil.branch == branch && fil.franchise == franchise && fil.maMappingCategoryName);
        }

        return groupedData || [];
    };

    let calculateOverallTotal = (catID, BranchID, Franchise) => {
        let Total_actual = 0;
        let Total_budget = 0;
        let Total_actualLY = 0;
        let Total_varLY = 0;
        let Total_variance = 0;
        let Total_ytdActual = 0;
        let Total_ytdActualLY = 0;
        let Total_ytdBudget = 0;
        let Total_ytdVarLY = 0;
        let Total_ytdVariance = 0;

        let filteredData = [];
        if (Franchise) {
            filteredData = dataList.filter((fil) => {
                const matchCategory = fil.maDashboardCategoryId == catID;
                const matchBranch = fil.branch == BranchID || BranchID == '-99';
                const matchFranchise = fil.franchise == Franchise;
                return matchCategory && matchBranch && matchFranchise;
            });
        } else if (BranchID == '-99') {
            filteredData = dataList.filter((fil) => {
                const matchCategory = fil.maDashboardCategoryId == catID;
                return matchCategory;
            });
        } else {
            filteredData = dataList.filter((fil) => {
                const matchCategory = fil.maDashboardCategoryId == catID;
                const matchBranch = fil.branch == BranchID;
                return matchCategory && matchBranch;
            });
        }
        let categoryCount = filteredData.length || 0;

        filteredData.forEach((data) => {
            Total_actual += data.actual;
            Total_budget += data.budget;
            Total_actualLY += data.actualLY;
            Total_varLY += data.varLY;
            Total_variance += data.variance;
            Total_ytdActual += data.ytdActual;
            Total_ytdActualLY += data.ytdActualLY;
            Total_ytdBudget += data.ytdBudget;
            Total_ytdVarLY += data.ytdVarLY;
            Total_ytdVariance += data.ytdVariance;
        });

        return {
            Total_actual,
            Total_budget,
            Total_actualLY,
            Total_varLY,
            Total_variance,
            Total_ytdActual,
            Total_ytdActualLY,
            Total_ytdBudget,
            Total_ytdVarLY,
            Total_ytdVariance,
            categoryCount
        };
    };

    let ByPassCalculationsTotal = (List, categoryId) => {
        let calTotal_actual = 0;
        let calTotal_budget = 0;
        let calTotal_actualLY = 0;
        let calTotal_varLY = 0;
        let calTotal_variance = 0;
        let calTotal_ytdActual = 0;
        let calTotal_ytdActualLY = 0;
        let calTotal_ytdBudget = 0;
        let calTotal_ytdVarLY = 0;
        let calTotal_ytdVariance = 0;
        let filteredData = List;

        filteredData.forEach((data) => {
            calTotal_actual += data.actual;
            calTotal_budget += data.budget;
            calTotal_actualLY += data.actualLY;
            calTotal_varLY += data.varLY;
            calTotal_variance += data.variance;
            calTotal_ytdActual += data.ytdActual;
            calTotal_ytdActualLY += data.ytdActualLY;
            calTotal_ytdBudget += data.ytdBudget;
            calTotal_ytdVarLY += data.ytdVarLY;
            calTotal_ytdVariance += data.ytdVariance;
            categoryId = categoryId;
        });

        return {
            calTotal_actual,
            calTotal_budget,
            calTotal_actualLY,
            calTotal_varLY,
            calTotal_variance,
            calTotal_ytdActual,
            calTotal_ytdActualLY,
            calTotal_ytdBudget,
            calTotal_ytdVarLY,
            calTotal_ytdVariance,
            categoryId
        };
    };

    useEffect(() => {
        let fetchDropOwn = async () => {
            let dropDownRes = await getManageAccountDropdown();
            const { year, period } = dropDownRes?.data?.period[0];
            const startYear = year - 7;
            const dynamicYears = Array.from({ length: year - startYear + 1 }, (_, index) => ({
                id: startYear + index,
                name: (startYear + index).toString()
            }));

            setDropDown((st) => ({
                ...st,
                branch: dropDownRes?.data?.branches.map((j) => ({ name: j.branchName, id: j.branchCode })),
                franchise: dropDownRes?.data?.franchiseRecords,
                period: { id: period, name: period.toString() },
                year: dynamicYears
            }));

            setState((st) => ({ ...st, period: period, yearID: year }));
        };
        return fetchDropOwn();
    }, []);

    useEffect(() => {
        let fetchData = async () => {
            try {
                if (screenDashboardID) {
                    let res = await getServDashScreenByCode(screenDashboardID);
                    if (res.success) {
                        let flagData = res?.data?.dashboard[0] || {};

                        setScreenDetails((st) => {
                            return {
                                ...st,
                                hasBranch: flagData.hasBranch || false,
                                hasFranchise: flagData.hasFranchise || false,
                                hasPeriod: flagData.hasPeriod || false,
                                hasYear: flagData.hasYear || false,
                                bgColor: flagData.bgColor || '#000000',
                                txtColor: flagData.txtColor || '#ffffff',
                                maDashboardID: flagData.maDashboardID || 1,
                                name: flagData.name || '',
                                defaultBranches: res?.data?.defaultBranches || [],
                                defaultFranchises: res?.data?.defaultFranchise || []
                            };
                        });
                        setCategoryList(res.data.categorytemplate);
                        setCatNames(res.data.categoryies);
                        setState((st) => ({ ...st, showYTD: flagData.hasYTD }));
                        setScreenLoader(false);
                    }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        return fetchData();
    }, [screenDashboardID]);

    useEffect(() => {
        setState((st) => {
            const newState = { ...st };
            if (screenDetails.hasBranch) {
                if (dropDown.branch.length > 0) {
                    if (screenDetails.defaultBranches.length > 0) {
                        newState.branchNewList = screenDetails.defaultBranches;
                    } else {
                        newState.branchNewList = [dropDown.branch[0]];
                    }
                }
            } else {
                newState.branchNewList = [];
            }

            // if (screenDetails.hasFranchise) {
            if (dropDown.franchise.length > 0) {
                if (screenDetails.defaultFranchises.length > 0) {
                    newState.franchise = screenDetails.defaultFranchises;
                } else {
                    newState.franchise = [];
                }
            }
            // }

            return newState;
        });
    }, [
        dropDown.branch,
        dropDown.franchise,
        screenDetails.hasBranch,
        screenDetails.hasFranchise,
        screenDetails.defaultFranchises,
        screenDetails.defaultBranches
    ]);

    let getData = async () => {
        setLoader(true);
        if (screenDashboardID && state.branchNewList.length > 0) {
            let res = await getServiceDashboardData(screenDashboardID, state.period, state.yearID, state.branchNewList, state.franchise);
            if (res.success) {
                setDataList(res?.data?.list);
                setState((st) => ({ ...st, isLoader: false }));
                setLoader(false);
            } else {
                setDataList([]);
                setState((st) => ({ ...st, isLoader: false }));
                setLoader(false);
            }
        }
    };

    const handleAccountCodes = () => {
        setState((st) => ({ ...st, openAccountCodes: !st.openAccountCodes }));
    };

    let getOverallAccountCodeData = async (catID, branch, franchise, maMappingCategoryName, mainCat) => {
        if (state.branchNewList.length > 0) {
            let res = await getAccountCodeData(catID, state.period, state.yearID, branch, franchise);
            if (res.success) {
                let getFren = '';
                let perd = '';
                let getBranch = '';
                setAccountCodes(res?.data?.table || []);

                if (branch) {
                    getBranch = dropDown.branch.find((k) => k.id === branch)?.name;
                }
                if (franchise) {
                    getFren = dropDown.franchise.find((k) => k.id === franchise).name;
                }
                if (state.period) {
                    perd = periodList.find((k) => k.id === state.period)?.name;
                }
                setAccountData((st) => ({ ...st, franchise: getFren, branch: getBranch, period: perd, catName: maMappingCategoryName, mainCat: mainCat }));
                handleAccountCodes();
            } else {
                for (let key in res.errors) {
                    if (res.errors.hasOwnProperty(key)) {
                        showToast(`${key}: ${res.errors[key].join(', ')}`);
                    }
                }
                setAccountCodes([]);
                setAccountData((st) => ({ ...st, franchise: '', branch: '', period: '', catName: '', mainCat: '' }));
            }
        }
    };

    const handlChange = (e) => {
        const { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    const BranchNullEntry = (branchArray, arrayWithoutBranch, catID, branch, calculated) => {
        const filteredBranchData = branchArray.filter((fil) => fil.maDashboardCategoryId === catID);

        const uniqueDataList = arrayWithoutBranch
            .reduce((acc, obj) => {
                var index = acc.find((item) => item.maMappingCategoryName === obj.maMappingCategoryName);
                if (index) {
                    index.budget = 0;
                    index.actualBudget = 0;
                    index.variance = 0;
                    index.actualLY = 0;
                    index.varLY = 0;

                    return acc;
                }
                acc.push({ ...obj });
                return acc;
            }, [])
            .filter(
                (fil) =>
                    !calculated &&
                    fil.maDashboardCategoryId === catID &&
                    fil.branch !== branch &&
                    !filteredBranchData.some((data) => fil.maMappingCategoryName === data.maMappingCategoryName)
            );

        return uniqueDataList || [];
    };
    const FrenchiseNullEntry = (array, franchise, categoryId, branch, calculated) => {
        let filteredBranchData = [];

        if (branch === '-99') {
            filteredBranchData = array.filter((fil) => !calculated && fil.maDashboardCategoryId === categoryId && fil.franchise === franchise);
        } else {
            filteredBranchData = array.filter((fil) => !calculated && fil.maDashboardCategoryId === categoryId && fil.franchise === franchise);
        }

        const uniqueDataList = array
            .reduce((acc, obj) => {
                var index = acc.find((item) => item.maMappingCategoryName === obj.maMappingCategoryName);
                if (index) {
                    index.budget = 0;
                    index.actualBudget = 0;
                    index.variance = 0;
                    index.actualLY = 0;
                    index.varLY = 0;

                    return acc;
                }
                acc.push({ ...obj });
                return acc;
            }, [])
            .filter(
                (fil) =>
                    !calculated &&
                    fil.maDashboardCategoryId === categoryId &&
                    (fil.branch !== branch || fil.franchise !== franchise) &&
                    !filteredBranchData.some((data) => fil.maMappingCategoryName === data.maMappingCategoryName)
            );

        return uniqueDataList || [];
    };

    useEffect(() => {
        if (state.branchNewList.length > 0) getData();
    }, [screenDashboardID, state.period, state.yearID, state.branchNewList, state.franchise]);

    const headerArray = [
        { name: null, align: 'left' },
        { name: portalSettingMADashboardActualName, align: portalSettingMADashboardActualAlign },
        { name: portalSettingMADashboardBudgetName, align: portalSettingMADashboardBudgetAlign },
        { name: portalSettingMADashboardVarianceName, align: portalSettingMADashboardVarianceAlign },
        { name: portalSettingMADashboardKPIsName, align: portalSettingMADashboardKPIsAlign },
        { name: portalSettingMADashboardActualPYName, align: portalSettingMADashboardActualPYAlign },
        { name: portalSettingMADashboardVarLYName, align: portalSettingMADashboardVarPYAlign }
    ];
    const headerArrayYTD = [
        { name: null, align: 'left' },
        { name: portalSettingMADashboardActualName, align: portalSettingMADashboardActualAlign },
        { name: portalSettingMADashboardBudgetName, align: portalSettingMADashboardBudgetAlign },
        { name: portalSettingMADashboardVarianceName, align: portalSettingMADashboardVarianceAlign },
        { name: portalSettingMADashboardKPIsName, align: portalSettingMADashboardKPIsAlign, isKpi: true },
        { name: portalSettingMADashboardActualPYName, align: portalSettingMADashboardActualPYAlign },
        { name: portalSettingMADashboardVarLYName, align: portalSettingMADashboardVarPYAlign },
        { name: portalSettingMADashboardActualName, align: portalSettingMADashboardActualAlign },
        { name: portalSettingMADashboardBudgetName, align: portalSettingMADashboardBudgetAlign },
        { name: portalSettingMADashboardVarianceName, align: portalSettingMADashboardVarianceAlign },
        { name: portalSettingMADashboardKPIsName, align: portalSettingMADashboardKPIsAlign, isKpi: true },
        { name: portalSettingMADashboardActualPYName, align: portalSettingMADashboardActualPYAlign },
        { name: portalSettingMADashboardVarLYName, align: portalSettingMADashboardVarPYAlign }
    ];

    let staatHeaderArray = [null, 'Actual', 'Budget', 'Variance'];

    const handleBranch = (event, value) => {
        setState((st) => {
            const nst = { ...st, branch: value.map((c) => c.id), branchNewList: value };
            return nst;
        });
    };
    const handleFranchise = (event, value) => {
        setState((st) => {
            const nst = { ...st, FrenchiseIds: value.map((c) => c.id), franchise: value };
            return nst;
        });
    };

    const handleDashboardChange = (e) => {
        setScreenLoader(true);
        setScreenDashboardID(e.target.value);
    };

    return (
        <BranchFranchiseCompareContext.Provider
            value={{
                headerArray,
                // BranchArray,
                staatHeaderArray,
                handleBranch,
                state,
                handleFranchise,
                categoryList,
                screenDetails,
                catName,
                dropDown,
                dataList,
                handlChange,
                calculateKIP,
                getBranchData,
                getFrenChiseData,
                getOverallAccountCodeData,
                accountCodes,
                handleAccountCodes,
                accountData,
                periodList,
                BranchNullEntry,
                FrenchiseNullEntry,
                handleShowYTD,
                headerArrayYTD,
                calculateOverallTotal,
                loader,
                tableRef,
                getCalculatedBranchData,
                getCalculatedFranchiseData,
                ByPassCalculationsTotal,
                Collapse,
                handleCollaps,
                setScreenDashboardID,
                screenDashboardID,
                handleDashboardChange,
                screenLoader,
                ThousandSeparatorWithoutZero
            }}
        >
            {props.children}
        </BranchFranchiseCompareContext.Provider>
    );
};
